<template>
  <div class="fund-review-notes-list">
    <template v-if="isNotesLoading">
     <mds-loader />
    </template>
    <template v-else>
      <span class="notes-title">Previous Notes</span>
      <template v-if="errorMsg">
        <div class="notes-list-error">
          <p>Something went wrong! We could not load the Historical Review Status/ Notes for this fund.</p>
          <p>Please refresh the page or try again later.</p>
        </div>
      </template>
      <template v-else-if="!notesListPresent">
        <p class="notes-list-error">Notes or Review Status history is not available for this Fund.</p>
      </template>
      <template v-else>
        <FundReviewNotesDetail
          v-for="notes in notesList"
          :key="notes.id"
          :notesDetail="notes"
        />
        <mds-pagination
          class="fund-review-notes-pagination"
          show-items-info
          show-items-select
          :total-items="totalRowsNumber"
          :pageSizes="gridPageSizeOptions"
          :pageSize="gridPageSize"
          :page="pageNumber"
          @mds-pagination-page-changed="handleTablePageChange($event)"
        >
        </mds-pagination>
      </template>
    </template>
  </div>
</template>

<script>
import MdsPagination from '@mds/pagination';
import MdsLoader from '@mds/loader';
import FundReviewNotesDetail from '@/components/molecules/FundReviewNotesDetail';
import * as FundReviewService from '@/services/FundReview';

const defaultPageSize = 5;
const defaultPageNumber = 1;
export default {
  name: 'fund-review-notes-list',
  components: {
    FundReviewNotesDetail,
    MdsPagination,
    MdsLoader,
  },
  props: {
    fundId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isNotesLoading: false,
      errorMsg: false,
      notesList: [],
      gridPageSizeOptions: [5, 10, 15],
      gridPageSize: defaultPageSize,
      totalRowsNumber: 0,
      pageNumber: defaultPageNumber,
    };
  },
  created() {
    this.loadNotesListData();
  },
  computed: {
    notesListPresent() {
      return !this.isNotesLoading && this.notesList.length > 0;
    },
  },
  methods: {
    loadNotesListData() {
      this.isNotesLoading = true;
      this.errorMsg = false;
      const pageNo = this.pageNumber - 1;
      const queryParams = `fiduciaryFundID=${this.fundId}&pageNo=${pageNo}&pageSize=${this.gridPageSize}&sortDirection=DESC`;
      FundReviewService.getFundReviewNotesHistory(queryParams).then((response) => {
        this.isNotesLoading = false;
        if (response.status.success) {
          this.notesList = response.data.content[0].fundReviewNotesHistories || [];
          this.totalRowsNumber = response.data.totalElements;
        }
      }).catch((error) => {
        this.isNotesLoading = false;
        this.handleError(error);
      });
    },
    resetNotesListPagination() {
      if (this.pageNumber === defaultPageNumber) {
        this.loadNotesListData();
      } else {
        this.pageNumber = defaultPageNumber;
      }
    },
    handleTablePageChange($event) {
      const { page, pageSize } = $event;
      this.gridPageSize = pageSize;
      this.pageNumber = page;
      this.loadNotesListData();
    },
    handleError(error) {
      const httpStatus = (error?.response?.status) ? (error?.response.status) : error?.status;
      if (httpStatus === 401) {
        this.$router.push('/login');
      } else {
        this.errorMsg = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .fund-review-notes-list {
    .notes-title {
      @include mds-body-text-m($bold: true);
    }
    .notes-list-error {
      text-align: center;
      margin-top: $mds-space-5-x;
      @include mds-body-text-l($bold: true);
    }
    .fund-review-notes-pagination {
      margin-top: $mds-space-5-x;
    }
  }
</style>
